import React from "react";

const INK = "#0E2018";
const GOLD = "#8a6a22";
const Label = ({ x, y, k, v, anchor = "middle", gold }) => (
    <g>
        <text x={x} y={y} textAnchor={anchor} fontSize="12" letterSpacing="2" fill={GOLD} className="font-sans uppercase">{k}</text>
        {v.map((l, i) => (
            <text key={l} x={x} y={y + 26 + i * 22} textAnchor={anchor} fontSize="19" fill={INK} className={`font-serif ${gold ? "" : "italic"}`}>{l}</text>
        ))}
    </g>
);

const Svg = ({ m }) => (
    <svg viewBox="-10 0 1220 720" className="w-full h-auto" role="img" aria-label="Mapa conceitual da investigação">
        <ellipse cx="600" cy="360" rx="400" ry="250" fill="none" stroke={INK} strokeOpacity="0.28" strokeDasharray="3 6" />
        <ellipse cx="600" cy="360" rx="280" ry="165" fill={INK} fillOpacity="0.03" stroke={INK} strokeOpacity="0.32" />
        <ellipse cx="600" cy="360" rx="130" ry="68" fill="#C7A659" fillOpacity="0.18" stroke={GOLD} strokeOpacity="0.6" />
        <Label x={372} y={150} k={m.contexto.k} v={[m.contexto.v]} />
        <Label x={445} y={232} k={m.campo.k} v={[m.campo.v]} />
        <text x="600" y="350" textAnchor="middle" fontSize="11" letterSpacing="2" fill={GOLD} className="font-sans uppercase">{m.centro.k}</text>
        <text x="600" y="378" textAnchor="middle" fontSize="22" fill={INK} className="font-serif">{m.centro.v}</text>
        {[[470, 360, 205, 360], [730, 360, 985, 360], [600, 292, 600, 92], [600, 428, 600, 628]].map(([a, b, c, d]) => (
            <line key={`${a}${b}`} x1={a} y1={b} x2={c} y2={d} stroke={GOLD} strokeOpacity="0.45" strokeDasharray="2 5" />
        ))}
        <Label x={100} y={340} k={m.nucleo.k} v={m.nucleo.v} gold />
        <rect x="-6" y="318" width="212" height="88" fill="none" stroke={GOLD} strokeOpacity="0.55" />
        <Label x={1100} y={300} k={m.transversais.k} v={["Fatores humanos", "e percepção", "·", "Tecnologia, IA", "e disrupção"]} />
        <Label x={600} y={38} k={m.lente.k} v={m.lente.v} />
        <Label x={600} y={658} k={m.resultado.k} v={m.resultado.v} />
    </svg>
);

const Mobile = ({ m }) => {
    const Item = ({ d, gold }) => (
        <div className={`px-4 py-3 ${gold ? "border border-[#8a6a22]/60" : "border-t border-[#0E2018]/15"}`}>
            <p className="font-sans text-[9.5px] uppercase tracking-[0.22em] text-[#8a6a22]">{d.k}</p>
            <p className="mt-1 font-serif text-[16px] leading-[1.35]">{[].concat(d.v).join(" ")}</p>
        </div>
    );
    return (
        <div className="flex flex-col gap-3">
            <Item d={m.lente} />
            <div className="border border-dashed border-[#0E2018]/30 p-3">
                <p className="font-sans text-[9.5px] uppercase tracking-[0.22em] text-[#8a6a22]">{m.contexto.k} · <span className="font-serif normal-case tracking-normal italic text-[14px] text-[#0E2018]">{m.contexto.v}</span></p>
                <div className="mt-3 border border-[#0E2018]/30 p-3">
                    <p className="font-sans text-[9.5px] uppercase tracking-[0.22em] text-[#8a6a22]">{m.campo.k}</p>
                    <p className="font-serif italic text-[14px]">{m.campo.v}</p>
                    <div className="mt-3 bg-[#C7A659]/20 border border-[#8a6a22]/60 px-3 py-4 text-center">
                        <p className="font-sans text-[9.5px] uppercase tracking-[0.22em] text-[#8a6a22]">{m.centro.k}</p>
                        <p className="mt-1 font-serif text-[19px]">{m.centro.v}</p>
                    </div>
                </div>
            </div>
            <Item d={m.nucleo} gold />
            <Item d={{ k: m.transversais.k, v: m.transversais.v.join(" · ") }} />
            <Item d={m.resultado} />
        </div>
    );
};

export const MapaInvestigacao = ({ m }) => (
    <figure data-testid="pesquisa-mapa">
        <div className="mb-8 flex flex-wrap items-center gap-3"><p className="font-sans text-[10.5px] uppercase tracking-[0.28em] text-[#8a6a22]">{m.title}</p></div>
        <div className="hidden lg:block"><Svg m={m} /></div>
        <div className="lg:hidden"><Mobile m={m} /></div>
        <figcaption data-testid="pesquisa-mapa-legenda" className="mt-6 font-sans text-[12px] leading-[1.7] text-[#5b6658] max-w-2xl">{m.legenda}</figcaption>
    </figure>
);
